import { Button, TextField, Tooltip } from "@mui/material";
import {
  DataGrid,
  GridColDef,
  GridColumnHeaderParams,
  GridRenderCellParams,
} from "@mui/x-data-grid";
import Switch from "react-switch";
import React, { useEffect, useRef, useState } from "react";
import { getAllBasket, updateBasket } from "../../services/manageBasketService";
import { Loader } from "../../components/loader/Loader";
import { defaultBasketConfig, ManageBasketConfig, manageBasketSearchParams } from "./ManageBasketConfig";
import "./ManageBasket.css";

import { useNavigate } from "react-router-dom";
import { metaDataBatchPayload, popupType } from "../../types/types";
import { ConfirmationPopUp } from "../../components/popup/confirmationPopUp";
import {
  basketDoaminType,
  basketRequestBody,
  valueType,
} from "./ManageBasketTypes";
import { GenericPopUp } from "../../components/popup/genericPopUp";
import { validateWithOtp } from "../../stateManagement/actions/validateOtpPopupActions";
import { manageUpdateAccessObj } from "../manageUpdateAccess/manageUpdateAccessTypes";
import { TranslationEnum, usePortalTranslation } from "../../providers/TranslationProvider";
import BackButton from "../../components/Buttons/BackButton/BackButton";
import { updateConfigRequestBody } from "../../services/managePoliciesService";
import { META_DATA_BATCH_API } from "../../services/networkService";
import { validateMetaDataResponse } from "../../services/uiConfigService";

const ManageBasket = (props: { hideBackButton?: boolean}) => {
  const { translate } = usePortalTranslation();
  const [rows, setRows] = useState<valueType[]>([]);
  const [loader, setLoader] = useState(true);
  const navigate = useNavigate();

  const [genericModalState, setGenericModalState] = useState(false);
  const [genericModalMessage, setGenericModalSMessage] = useState("");
  const [genericModaltype, setGenericModalType] = useState<popupType>("Error");

  const [confirmationPopUp, setConfirmationPopUp] = useState(false);
  const [popUpMessage, setPopUpMessage] = useState<string>("");
  const popUpSuccessMethod = useRef<any>();
  const basketConfigurationRef = useRef<any>([]);
  const allBasketsRef = useRef<any[]>([]);
  const [searchText,setSearchText] = useState<string>("");

  const domainValues = useRef<basketDoaminType[] | null>(null);

  const openPopUp = (message: string, modalType: popupType) => {
    setGenericModalSMessage(message);
    setGenericModalState(true);
    setGenericModalType(modalType);
  };
  const defaultFilter = (dataValue: string, searchedValue: string) => {
    if (!dataValue) {
        return;
    }
    dataValue = dataValue.toString();
    return dataValue.toLowerCase().includes(searchedValue.toLowerCase());
  };
  const filterBasketData = (search: string) => {
    if (search) {
        const newData = allBasketsRef.current.filter((basketObj) => {
            const isPresent = manageBasketSearchParams.filter(
                (searchParam) => {
                      return defaultFilter(basketObj[searchParam], search);
                }
            );
            if (isPresent.length !== 0) {
                return true;
            } else {
                return false;
              }
          });
          setRows(newData);
      } else {
          setRows(allBasketsRef.current);
      }
  };
  const getAllBasketData = async () => {
    try {
      const response = await getAllBasket();
      const orderBasketConfigData = response?.data?.features.find(
        (eachConfig: any) => {
          return eachConfig.domainType === "order_basket_configuration";
        }
      );
      if (orderBasketConfigData) {
        domainValues.current = orderBasketConfigData.domainValues;
        if (domainValues.current) {
          const allBasketData = domainValues.current[0].value;
          if(allBasketData){
            setRows(allBasketData);
            allBasketsRef.current = allBasketData;
            setLoader(false);
          }
          else{
            throw new Error();
          }
        } else {
          throw new Error();
        }
      }
      else{
        domainValues.current = defaultBasketConfig;
        const allBasketData = domainValues.current[0].value;
          if(allBasketData){
            setRows(allBasketData);
            setLoader(false);
          }
      }
    } catch (error) {
      setRows([]);
      openPopUp("Something went wrong", "Error");
      setLoader(false);
    }
  };

  useEffect(() => {
    getAllBasketData();
  }, []);
  const columns: GridColDef[] = ManageBasketConfig.columns.map(
    (columnsMetaData) => {
      return {
        disableColumnMenu: true,
        field: columnsMetaData.mappedValue,
        headerName: columnsMetaData.headerName,
        sortable: false,
        minWidth: 100,
        flex: 1,
        headerAlign: "left",
        align: "left",
        renderHeader: (params: GridColumnHeaderParams) => (
          <Tooltip title={columnsMetaData.headerName}>
            <b>{translate(TranslationEnum.manage_basket,columnsMetaData.headerName)}</b>
          </Tooltip>
        ),
      };
    }
  );

  const addActionAttributes = (
    field: string,
    headerName: "",
    action: (params: GridRenderCellParams) => JSX.Element
  ) => {
    columns.push({
      field,
      headerName,
      sortable: false,
      minWidth: 90,
      flex: 0.6,
      headerAlign: "left",
      align: "left",
      disableColumnMenu: true,
      renderCell: action,
    });
  };

  const updateConfirmationPopData = (
    message: string,
    methodHelper: () => void
  ) => {
    popUpSuccessMethod.current = methodHelper;
    setPopUpMessage(message);
  };

  const updateBasketData = async (id: string, action: string,verifiedUser?: manageUpdateAccessObj) => {
    try {
      let newValue;
      if (action === "delete")
        newValue = allBasketsRef.current.filter((eachRow: valueType) => {
          return eachRow.id !== id;
        });
      else {
        newValue = allBasketsRef.current.map((eachRow: valueType) => {
          if (eachRow.id === id) {
            return {
              ...eachRow,
              status: eachRow.status === "active" ? "inactive" : "active",
            };
          }
          return eachRow;
        });
      }
      if (domainValues.current) {
        domainValues.current[0].value = newValue;
      }
      const basketDataPayload: updateConfigRequestBody = {
        domainName: "clientconfig",
        domainType: "order_basket_configuration",
        domainValues: domainValues.current as any,
        lob: JSON.parse(localStorage.authContext).user.lob,
      };
      const finalMetaDataPayload: metaDataBatchPayload = { features: [basketDataPayload] };
      validateWithOtp((verifiedUser?: manageUpdateAccessObj,verifyResponse?: any) => {
        if (verifyResponse.status >= 200 || verifyResponse.status < 300) {
          const validationObj = validateMetaDataResponse(verifyResponse?.data?.features);
          if(validationObj.success){
            setSearchText("");
            setLoader(true);
            getAllBasketData();
          }else{
           openPopUp(validationObj.message,"Error");
          }
        } else {
          openPopUp("Something went wrong", "Error");
        }
      },undefined,"all",META_DATA_BATCH_API,finalMetaDataPayload,"PUT");
    } catch (error) {
      openPopUp("Something went wrong", "Error");
    }
  };

  ManageBasketConfig.Actions.forEach((actionName: string) => {
    switch (actionName) {
      case "Update":
        addActionAttributes("Update", "", (params: GridRenderCellParams) => {
          return (
            <button
              className="manage-basket-table-button"
              onClick={() => {
                navigate("createBasket", {
                  state: {
                    row: params.row,
                    domainValues: domainValues.current,
                  },
                });
              }}
            >
             {translate(TranslationEnum.common_portal,"UPDATE")}
            </button>
          );
        });
        break;
      case "Delete":
        addActionAttributes("Delete", "", (params: GridRenderCellParams) => {
          return (
            <button
              className="manage-basket-table-button"
              onClick={() => {
                setConfirmationPopUp(true);
                updateConfirmationPopData(
                  "Are you sure you want to delete the basket",
                  () => {
                    updateBasketData(params?.row?.id, "delete");
                  }
                );
              }}
            >
             {translate(TranslationEnum.common_portal,"DELETE")}
            </button>
          );
        });
        break;
      case "ChangeStatus":
        addActionAttributes(
          "ChangeStatus",
          "",
          (params: GridRenderCellParams) => {
            return (
              <Switch
                onChange={() => {
                  setConfirmationPopUp(true);
                  updateConfirmationPopData(
                    params.row.status === "active"
                      ? "Are you sure you want to deactivate the basket"
                      : "Are you sure you want to activate the basket",
                    () => {
                     updateBasketData(params?.row?.id, "update"); 
                    }
                  );
                }}
                checked={params.row.status === "active" ? true : false}
                offColor="#909090"
                onColor="#24c6b1"
                size={30}
                handleDiameter={25}
                uncheckedIcon={
                  <>
                     <div className="manage-home-screen-toggle-unchecked-icon-status">{translate(TranslationEnum.common_portal,"INACTIVE")}</div>
                  </>
                }
                checkedIcon={
                  <>
                    <div className="manage-home-screen-toggle-checked-icon-status">{translate(TranslationEnum.common_portal,"ACTIVE")}</div>
                  </>
                }
                height={28}
                width={85}
              />
            );
          }
        );
    }
  });

  

  return (
    <>
      <div className="manage-basket-parent">
        <div className="manage-basket-header">
          <div className="manage-basket-label">
            <span>{translate(TranslationEnum.manage_basket,"Manage Basket")}</span>
          </div>
          <div className="manage-basket-buttons">
            <TextField
              label={translate(TranslationEnum.common_portal,"Search")}
              name="manageBannerSearch"
              value={searchText}
              size="small"
              onChange= {(event) => {
                setSearchText(event.target.value);
                filterBasketData(event.target.value);
              }}
            />
            <Button
              className="manage-basket-create-new"
              onClick={() => {
                navigate("createBasket", {
                  state: {
                    row: {
                      id: "",
                      tag: "",
                      type: "",
                      title: "",
                      tagColor: "",
                      subtitle: "",
                      status: "",
                      backgroundImageBlobKey: "",
                      displayImageBlobKey: "",
                      basketTitleIconBlobKey: "",
                      backGroundColor:"",
                      titleColor:"",
                      subTitleColor:""
                    },
                    domainValues: domainValues.current,
                  },
                });
              }}
            >
              {translate(TranslationEnum.manage_basket,"Create Basket").toUpperCase()}
            </Button>
            {!props.hideBackButton && <BackButton/>}
          </div>
        </div>
        {loader ? (
          <Loader />
        ) : (
          <div className="manage-basket-table">
            <DataGrid
              disableRowSelectionOnClick={true}
              sx={{
                "&.MuiDataGrid-root .MuiDataGrid-cell:focus-within": {
                   outline: "none !important",
                },
             }}
              rows={rows}
              columns={columns}
              initialState={{
                sorting: {
                  sortModel: [{ field: "id", sort: "asc" }],
                },
              }}
              componentsProps={{
                pagination: {
                  labelRowsPerPage: translate(TranslationEnum.common_portal,"Rows per page"),
                },
              }}
              
            />
          </div>
        )}

        <ConfirmationPopUp
          openConfirmModal={confirmationPopUp}
          message={popUpMessage}
          setOpenConfirmModal={() => {
            setConfirmationPopUp(false);
          }}
          successMethod={popUpSuccessMethod.current}
        />
        <GenericPopUp
          type={genericModaltype}
          message={genericModalMessage}
          openGenericModal={genericModalState}
          setOpenGenericModal={() => {
            genericModaltype === "Success" && getAllBasketData();
            setGenericModalState(false);
          }}
        />
      </div>
    </>
  );
};

export default ManageBasket;
